import { Router } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class AuthService {
  //token: string;
  private token: JSON;
  loggedIn: boolean;
  username: string;
  tryRelog: boolean = false;

  constructor(
    private router: Router) { }

  signupUser(email: string, password: string) {
    //your code for signing up the new user
  }

  signinConsumer(data: JSON) {
    this.loggedIn = true;
    this.router.navigate(['pages/consumer_profile']);
    this.token = data;
  }

  logoutConsumer() {
    this.loggedIn = false;
    this.router.navigate(['pages/consumerlogin']);
    this.token = null;
  }

  signinUser(data: JSON) {
    this.token = data;
    if (this.checkRights('TERAD')) {
      this.router.navigate(['va/terminals']);
    } else if (this.checkRights('PMDBD')) {
      this.router.navigate(['va/products']);
    } else if (this.checkRights('ACCOU')) {
      this.router.navigate(['va/accounting']);
    } else if (this.checkRights('DLCAD')) {
      this.router.navigate(['va/dlc']);
    } else if (this.checkRights('EPROF')) {
      this.router.navigate(['pages/profile']);
    } else {
      this.router.navigate(['va/faq']);
    }

    this.loggedIn = true;
    //console.log(this.token);
  }

  logout() {
    this.token = null;
    this.router.navigate(['pages/login']);
    this.loggedIn = false;
  }

  relogInUser() {
    this.loggedIn = true;
  }

  relogUser(): string {
    //console.log("try relog");
    return '{"action": "userlogin","company": "' + this.token['data']['userdata']['companyshort'] + '","username": "' + this.username + '","password": "' + this.token['data']['relogkey'] + '", "do": "relogin","call_from": "relogin"}';
  }

  getToken() {
    return this.token;
  }

  checkRights(right: string) {
    if (this.token == null || (this.token['data']['userdata']['rights'].indexOf(right) == -1 && right != 'none')) {
      return false;
    }
    return true;
  }

  getComapnyId(): string {
    if (this.token) {
      return this.token['data']['userdata']['company_id'];
    }
    return "";
  }

  getCompany(): string {
    if (this.token) {
      return this.token['data']['userdata']['companyshort'];
    }
    return "";
  }

  getUserId(): string {
    if (this.token) {
      return this.token['data']['userdata']['user_id'];
    }
    return "";
  }

  getUser(): string {
    if (this.token) {
      return this.token['data']['user'];
    }
    return "";
  }

  isAuthenticated() {
    // here you can check if user is authenticated or not through his token
    if (this.token != null && this.token['success']) {
      return true;
    }
    return false;
  }
}
